import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {Header, Modal} from 'semantic-ui-react';

import {gql, graphql} from 'react-apollo';
import {createForm, renderModalError} from '@utils/forms';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';
import {isUrlParamValid} from '@utils/helpers';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import Link, {getLink} from '@appComponents/Link';
import mapModulesToProps from '@utils/mapModulesToProps';
import {sortByTextValue} from '@utils/sorters';
import {exportExcel} from '@modules/client/utils/export/clientAnalyticsSetupLabelsIndexExcel';
import * as clientAnalyticsSetupLabelsGraphQl from '@graphql/clients/clientLabels';
import {CLIENT_ANALYTICS_SETUP_LABLES_TABLE_MAX_NUMBER} from '@modules/client/constants/messages';
import ClientAnalyticsSetupLabelForm from '@modules/client/forms/ClientAnalyticsSetupLabelForm';
import ClientAnalyticsSetupLabelModel from '@modules/client/forms/ClientAnalyticsSetupLabelModel';
import ClientAnalyticsSetupLabelModelEdit from '@modules/client/forms/ClientAnalyticsSetupLabelModelEdit';
import ClientAnalyticsSetupLabelsIndexButtons from '@modules/client/components/ClientAnalyticsSetupLabelsIndexButtons';
import ClientAnalyticsSetupLabelsTable from '@modules/client/components/ClientAnalyticsSetupLabelsTable';

export class ClientAnalyticsSetupLabelsIndex extends React.Component {
    static propTypes = {
        clientId: PropTypes.number.isRequired,
        DataClientAnalyticsSetupLabels: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        Modal: PropTypes.object.isRequired,
        modal: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            clientLabelsOriginal: [],
            clientLabels: [],
        };

        this.maxNumberOfClientLabels = 50;
    }

    static getDerivedStateFromProps(nextProps, nextState) {
        const {DataClientAnalyticsSetupLabels: {clientLabels}, match} = nextProps;

        if (clientLabels && clientLabels !== nextState.clientLabelsOriginal) {
            return {
                clientLabelsOriginal: clientLabels,
                clientLabels: sortByTextValue(clientLabels, 'code'),
            };
        }

        if (match.path === routes.clients.clientAnalyticsSetup.labels.add.path) {
            return {
                showModalForAddRoute: true,
            };
        }

        return null;
    }

    componentDidMount() {
        const {DataClientAnalyticsSetupLabels: {clientLabels}} = this.props;

        if (clientLabels) {
            this.loadModal(this.props.match.path, {clientLabels});
        }
    }

    componentDidUpdate(prevProps) {
        const { DataClientAnalyticsSetupLabels: { clientLabels }, modal } = this.props;

        if (clientLabels !== prevProps.DataClientAnalyticsSetupLabels.clientLabels) {
            this.setState({
                clientLabelsOriginal: clientLabels,
                clientLabels: sortByTextValue(clientLabels, 'code'),
            });

            this.loadModal(this.props.match.path, { clientLabels });
        }

        const urlChanged = this.props.match.path !== prevProps.match.path;
        const urlIsNotIndex = this.props.match.path !== routes.clients.clientAnalyticsSetup.labels.index.path;
        const shouldOpenModal = urlChanged && urlIsNotIndex;

        if (shouldOpenModal) {
            this.loadModal(this.props.match.path, {
                ...this.props.match.params,
                clientLabels: clientLabels,
            });
        }

        const modalChanged = modal.isVisible !== prevProps.modal.isVisible;
        const modalIsNotVisible = !modal.isVisible;
        const modalWasClosed = modalChanged && modalIsNotVisible;

        if (modalWasClosed) {
            this.props.history.push(
                getLink('clients.clientAnalyticsSetup.labels.index', { id: this.props.match.params.id })
            );
        }
    }


    showMaxNumberOfClientLabelsModal = () => {
        this.props.Modal.setModal({
            content: (
                <div>
                    <Header
                        color='red'
                        content={'Error'}
                        icon='warning'
                    />
                    <Modal.Content>
                        <p>
                            {CLIENT_ANALYTICS_SETUP_LABLES_TABLE_MAX_NUMBER(this.maxNumberOfClientLabels)}
                        </p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Link
                            name='clients.clientAnalyticsSetup.labels.index'
                            params={{id: this.props.match.params.id}}
                        >
                            Back to the list of labels
                        </Link>
                    </Modal.Actions>
                </div>
            ),
            isVisible: true,
        });
    };

    loadModal(path, params = {}) {
        if (!isUrlParamValid(this.props.match.params.id)) {
            return showModal({
                isVisible: true,
                content: renderModalError('Client', routes.clients.index.path),
            });
        }

        if (!isUrlParamValid(this.props.match.params.clientLabelId)) {
            return showModal({
                isVisible: true,
                content: renderModalError('Label', getLink('clients.clientAnalyticsSetup.labels', {
                    id: this.props.match.params.id,
                })),
            });
        }

        switch (path) {
            case routes.clients.clientAnalyticsSetup.labels.add.path:
                if (params.clientLabels.length >= this.maxNumberOfClientLabels) {
                    this.showMaxNumberOfClientLabelsModal();

                    return false;
                }

                return this.loadModalForm(createForm(
                    ClientAnalyticsSetupLabelModel,
                    ClientAnalyticsSetupLabelForm,
                    {
                        optionsVariables: {
                            id: parseInt(this.props.match.params.id, 10),
                        },
                    }
                ), params);
            case routes.clients.clientAnalyticsSetup.labels.edit.path:
                return this.loadModalForm(createForm(
                    ClientAnalyticsSetupLabelModelEdit,
                    ClientAnalyticsSetupLabelForm,
                    {
                        id: this.props.match.params.clientLabelId || params.clientLabelId,
                        dataRequest: true,
                        optionsVariables: {
                            id: parseInt(this.props.match.params.id, 10),
                        },
                    }
                ), params);
        }
    }

    loadModalForm = (Form, data) => {
        this.props.Modal.setModal({
            isVisible: true,
            header: null,
            content: <Form formData={data}/>,
        });
    };

    render() {
        let header = this.state.clientLabels.length >= this.maxNumberOfClientLabels
            ? (
                <p className='__tableNote'>
                    {CLIENT_ANALYTICS_SETUP_LABLES_TABLE_MAX_NUMBER(this.maxNumberOfClientLabels)}
                </p>
            )
            : (
                <HeaderRenderer
                    buttons={ClientAnalyticsSetupLabelsIndexButtons}
                    buttonsProps={{id: parseInt(this.props.match.params.id, 10)}}
                    exportExcelParams={exportExcel(this.state.clientLabels, this.props.match.params.id)}
                    loading={this.props.DataClientAnalyticsSetupLabels.loading}
                />
            );

        return (
            <div>
                {header}
                <div className='clearfix'/>
                <ClientAnalyticsSetupLabelsTable
                    clientId={parseInt(this.props.match.params.id, 10)}
                    clientLabels={this.state.clientLabels}
                    loading={this.props.DataClientAnalyticsSetupLabels.loading}
                />
            </div>
        );
    }
}

const ClientAnalyticsSetupLabelsQuery = gql(clientAnalyticsSetupLabelsGraphQl.clientLabelsQuery);

const mapStateToProps = (state) => {
    return {
        modal: state.modal,
    };
};

const mapDispatchToProps = mapModulesToProps(['Modal']);

export default compose(
    graphql(ClientAnalyticsSetupLabelsQuery, {
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    client: props.clientId,
                },
            };
        },
        name: 'DataClientAnalyticsSetupLabels',
    })
)(withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientAnalyticsSetupLabelsIndex)));
